module.exports = __webpack_public_path__ + "img/process_small@2x.cdf435e5.jpg";